<template>
  <div class="layout-with-centered-max-width-child">
    <div>
          <div v-if="this.loadingStatus === loadingStarted">
            <loading></loading>
          </div>
          <div v-else-if="this.loadingStatus === loadingSuccessful">
            <div class="myprofile-container">
              <div class="heading-container">
                <div class="font-secondary heading">My Profile</div>
              </div>
              <div class="each-row">
                <div class="left-side">Name</div>
                <div class="right-side">
                  <input class="input-box" v-model="updatedInfo.username" placeholder="Name Goes here">
                </div>
              </div>
              <div class="each-row">
                <div class="left-side">Email</div>
                <div class="right-side">
                  <div class="input-box-frozen">{{getEmailAddress}}</div>
                </div>
              </div>
              <div class="each-row">
                <div class="left-side">Gender</div>
                <div class="right-side">
                  <Dropdown :selection=this.genders[updatedInfo.gender-1]>
                    <div class="option" v-for="gender in genders" @click="setGender(gender)">{{gender}}</div>
                  </Dropdown>
                </div>
              </div>
              <div class="each-row">
                <div class="left-side">Country</div>
                <div class="right-side">
                  <Dropdown :selection=updatedInfo.country>
                    <div class="option" v-for="country in countries" @click="setCountry(country)">{{country}}</div>
                  </Dropdown>
                </div>
              </div>
              <div class="each-row">
                <div class="left-side">Birthdate</div>
                <div class="right-side">
                  <Datepicker class="date-picker"
                              input-class="myprofile-date-picker"
                              :format="datePickerDateFormat"
                              :value=updatedInfo.birthDay
                              @input="modifyDate"></Datepicker>
                </div>
              </div>
              <div class="each-row">
                <div>
                  <div class="checkbox">
                    <input type="checkbox" v-model="updatedInfo.hideName">
                  </div>
                  Keep Name Private
                </div>
              </div>
              <div class="each-row">
                <div>
                  <div class="checkbox">
                    <input type="checkbox" v-model="updatedInfo.hideEmail">
                  </div>
                  Keep Email Private
                </div>
              </div>
              <div class="each-row">
                <div>
                  <button class="pure-button bigmi-red-2-button" v-show="profileInfoChanged" v-on:click="saveUpdatedProfile">Save</button>
                </div>
              </div>
              <div class="each-row">
                <div class="footer-bar">
                  <div class="inner-footer"> </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="this.loadingStatus === loadingFailed">
            <div class="centered-row">
              <ErrorPage>
                <div slot="header">ERROR</div>
                <div slot="message">Sorry, there was an error loading the page</div>
              </ErrorPage>
            </div>
          </div>
    </div>
  </div>
</template>

<script>

  import Dropdown from "../general/Dropdown"
  import {DatepickerAsync} from '../views/DatePickerAsync'
  import {
    CSS_CLASS_NAME_DATEPICKER_INPUT,
    CSS_CLASS_NAME_INVALID,
    DATE_FORMAT_DATEPICKER,
    GET_BACKEND_URL,
    GET_HTTP_CONFIG,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_STARTED
  } from "../../services/constants"
  import http from "../../services/axios"
  import {formatBirthday} from '../../services/utilities'
  import ErrorPage from "./ErrorPage"


  export default {
        name: "MyProfile",

        components: {
          ErrorPage,
          Dropdown,
          'Datepicker': DatepickerAsync,
        },

        beforeCreate(){
          http.get(this.$store.getters[GET_BACKEND_URL](`users/current`), this.$store.getters[GET_HTTP_CONFIG]).then(response => {
            this.originalInfo = this.updateUserInfo(response.data)
            this.updatedInfo = this.updateUserInfo(response.data)
            this.loadingStatus = LOADING_COMPLETED_SUCCESS
          })
          .catch(err =>{
            console.log(err)
            this.loadingStatus = LOADING_COMPLETED_FAILURE
          })
        },

        data(){
            return{
              originalInfo: this.createUserInfoTemplate(),
              updatedInfo: this.createUserInfoTemplate(),
              loadingStatus: LOADING_STARTED
            }
          },

        computed: {
          getEmailAddress(){
            return this.updatedInfo.email
          },
          isBirthDateValid() {
            return !!this.birthDay
          },
          showBirthDateValidationUI() {
            return !this.isBirthDateValid
          },
          birthDateValidationClassObj() {
            return {
              [CSS_CLASS_NAME_INVALID]: this.showBirthDateValidationUI
            }
          },
          datePickerWrapperClass() {
            return CSS_CLASS_NAME_DATEPICKER_INPUT
          },
          datePickerDateFormat() {
            return DATE_FORMAT_DATEPICKER
          },
          profileInfoChanged(){
            return !this.deepEqual(this.originalInfo, this.updatedInfo)
          },
          genders(){
            return ['Male', 'Female']
          },
          countries(){
            return this.$store.state.dataModule.countries.data.map(countryobj => countryobj.name)
          },
          loadingStarted(){
            return LOADING_STARTED
          },
          loadingSuccessful(){
            return LOADING_COMPLETED_SUCCESS
          },
          loadingFailed(){
            return LOADING_COMPLETED_FAILURE
          },
        },

        methods: {

          setGender(evt){
            this.updatedInfo.gender = this.genders.indexOf(evt)+1
          },

          setCountry(evt){
            this.updatedInfo.country = evt
          },

          saveUpdatedProfile(){
            http.post(this.$store.getters[GET_BACKEND_URL](`users/current`), this.updatedInfo, this.$store.getters[GET_HTTP_CONFIG]).then(response => {
              this.originalInfo = Object.assign({}, this.updatedInfo)
            }).catch(err => {
              console.error(err)
            })
          },

          createUserInfoTemplate(){
            let userInfo = {
              country: '',
              gender: 0,
              email: '',
              username: '',
              birthDay: '',
              hideEmail: false,
              hideName: false,
            }
            return userInfo
          },

          updateUserInfo(data){
            return Object.assign({}, this.updatedInfo, data)
          },

          deepEqual(a, b) {
            if (a && b && typeof a == 'object' && typeof b == 'object') {
              if (Object.keys(a).length != Object.keys(b).length) return false;
              for (var key in a) if (!this.deepEqual(a[key], b[key])) return false;
              return true;
            } else return a === b
          },

          modifyDate(evt){
            this.updatedInfo.birthDay = formatBirthday(evt)
          },

        },
    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .heading{
    color: $red-2;
    font-size: 20px;
    font-weight: 900;
  }

  .date-picker{
    width: 100%;
    color: black;
    background-color: $gray-1;
  }

  .myprofile-container{
    padding: 0 5%;
  }

  .heading-container{
    padding: 3% 0;
  }

  .left-side{
    display: inline-block;
    width: 10%;
    @media #{$mobile} {
      width: 25%;
    }
  }

  .right-side{
    display: inline-block;
    width: 30%;
    @media #{$mobile} {
      width: 75%;
    }
  }

  .input-box{
    width: 100%;
    border: $gray-1;
    height: 40px;
    background-color: $gray-1;
    text-indent:10px;
  }

  .input-box-frozen{
    width: 100%;
    border: $gray-1;
    height: 40px;
    color: black;
    background-color: $gray-1;
    text-indent:10px;
    display: flex;
    align-items: center;
  }

  .each-row{
    padding: 5px 0;
  }

  .footer-bar {
    width: 100%;
  }
  .inner-footer {
    display:inline-block;
    width: 100%;
    height: 2px;
    background-color: $gray-2;
  }

  .checkbox{
    display: inline-block;
    padding: 0 5px;
  }

  .option {
    padding: 5px 20px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  .option:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

</style>
